/**
 * Единый рубильник видимости функций, временно скрытых из UI (задача 100 §1.2).
 *
 * Каждый флаг = одна функция. `false` прячет её на ВСЕХ поверхностях сразу
 * (рейл, вкладки, страницы), `true` возвращает — код функции остаётся в проекте,
 * восстановление = флип флага. Один источник правды: рейл, `ProjectDetailPage`
 * и route-гейты читают отсюда, а не держат свои локальные константы.
 *
 * Это НЕ система прав и НЕ защита данных: права приходят из ролей и орг-дерева.
 * Флаги скрывают функцию из навигации; по прямому URL страница может остаться
 * доступной, если у неё нет собственного route-гейта (у `/risks` гейт есть).
 * См. `docs/frontend/patterns.md §Фича-флаги видимости`.
 *
 * Скрыто по просьбе владельца (Антон, 11.07.2026) — функции пока не в ходу.
 */
export type FeatureFlag = "decisions" | "risks";

export const FEATURES: Record<FeatureFlag, boolean> = {
  /** Секция «Решения» в рейле: Портфель / Загрузка / Риски / Согласования. */
  decisions: false,
  /** Функция «Риски»: таб «Риски» карточки проекта и страница `/risks`. */
  risks: false,
};
